module.exports = __webpack_public_path__ + "img/icon-aibus.03697b5a.svg";